import React from "react";
import { createRocket } from "../_util/create-rocket";
import { useConfig } from "../_util/config-context";
export var SegmentGroup = createRocket("Group", "div.@{prefix}-region-pave");
export function SegmentGroupItem(_a) {
    var name = _a.name, children = _a.children;
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", { className: classPrefix + "-region-pave__item" },
        React.createElement("span", { className: classPrefix + "-region-pave__area-name" },
            React.createElement("i", null, name)),
        children));
}
SegmentGroupItem.displayName = "SegmentGroupItem";
//# sourceMappingURL=SegmentGroup.js.map